<template>
  <transition enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutUp" :duration="450">
    <div v-if="getNotificationDisplayed" class="notification-container">
      <v-touch @swipeup="close">
        <div class="notification">
          <img v-if="getNotificationIcon" :src="getNotificationIcon" :alt="$t('notification')">
          <div :class="{ 'content': getNotificationIcon, 'content-space': !getNotificationIcon }">
            <template v-for="(messageItem, messageIndex) in getNotificationMessage">
              <router-link v-if="messageItem.href" :key="messageIndex" :to="messageItem.href">{{ messageItem.label }}</router-link>
              <span v-else :key="messageIndex">{{ messageItem }}</span>
            </template>
          </div>
          <button class="close" @click="close">
            <svgicon name="close" :alt="$t('close')" />
          </button>
        </div>
      </v-touch>
    </div>
  </transition>
</template>

<script>

import '@/lib/icons/close';
import { mapGetters, mapActions } from '@/lib/vue';

export default {
  data() {
    return {
      timeoutID: null,
    };
  },
  computed: {
    ...mapGetters(['getNotificationDisplayed', 'getNotificationIcon', 'getNotificationMessage']),
  },
  watch: {
    getNotificationDisplayed(value) {
      if (value === true) {
        this.setHideNotificationTimeout();
      } else {
        this.clearHideNotificationTimeout();
      }
    },
  },
  methods: {
    ...mapActions(['hideNotification']),
    close() {
      this.hideNotification();
      this.clearHideNotificationTimeout();
    },
    setHideNotificationTimeout() {
      this.timeoutID = window.setTimeout(this.hideNotification, 4000);
    },
    clearHideNotificationTimeout() {
      if (this.timeoutID) {
        window.clearTimeout(this.timeoutID);
      }
    },
  },
};
</script>

<style lang="scss" scoped>


  .animated {
    animation-duration: 450ms;
  }

  .content-space {
    width: 100%;
    text-align: left;
    margin-left: 1rem;
  }

  .notification-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 101;

    .notification {
      background: linear-gradient(to bottom, #fdfdfd, #fcfcfc);
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid $pearl-300;
      min-height: 4rem;
      box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.1);

      img {
        width: 2rem;
        min-width: 2rem;
        margin: 0 0.5rem 0 1rem;
      }

      .content {
        width: 100%;
        text-align: left;
        margin-left: 1rem;
      }

      .close {
        display: block;
        color: $black;
        background: none;
        box-shadow: none;
        padding: 0;
        height: auto;
        cursor: pointer;
        margin: 0 1rem 0 0.5rem;

        svg {
          fill: $black;
          stroke: $black;
        }
      }
    }

    @media #{$screen-width-small} {
      left: auto;
      right: 0.5rem;
      width: 24rem;

      .notification {
        height: auto;
        border-radius: 0.25rem;
        border: 1px solid $pearl-300;
        padding: 1.2rem 0;
        margin-top: 0.5rem;

        .close {
          margin-right: 0.5rem;
        }
      }
    }
  }
</style>
